import { render, staticRenderFns } from "./CalculadoraProducto.vue?vue&type=template&id=6b3a98f4&scoped=true&"
import script from "./CalculadoraProducto.vue?vue&type=script&lang=js&"
export * from "./CalculadoraProducto.vue?vue&type=script&lang=js&"
import style0 from "./CalculadoraProducto.vue?vue&type=style&index=0&id=6b3a98f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3a98f4",
  null
  
)

export default component.exports